import partners from './partners';
import eduzz from './eduzz';
import novo from './new';
import company from './company';

export default {
  default: novo,
  company,
  partners,
  eduzz,
  seven: eduzz,
};
